var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiNanaBo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_16282_90556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48.5,
    r: 24,
    fill: "url(#paint0_linear_16282_90556)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48.5,
    r: 24,
    fill: "#141922"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5544 59.1667C50.293 59.168 49.0434 58.9229 47.8746 58.4449C48.4312 58.1638 48.9467 57.8066 49.4063 57.3833C49.8636 56.9625 50.2605 56.4797 50.5858 55.9487C51.2599 54.8503 51.5957 53.5753 51.551 52.2847C51.5088 51.0517 51.1274 49.8547 50.4493 48.8275C49.7712 47.8002 48.823 46.9831 47.7107 46.4673L47.7086 46.4656L47.7078 46.463L47.7084 46.4604L47.7103 46.4584C48.4805 45.9865 49.1202 45.3265 49.5704 44.5396C49.993 43.7984 50.2336 42.966 50.272 42.1121C50.3104 41.2581 50.1456 40.4072 49.7913 39.6305C51.0272 39.4043 52.2946 39.4179 53.5254 39.6705C54.7762 39.9284 55.9644 40.4319 57.0222 41.1523C58.5942 42.221 59.8249 43.7261 60.5651 45.4853C60.815 46.081 61.0058 46.7002 61.1347 47.3339C61.3996 48.6436 61.3996 49.9937 61.1347 51.3034C60.8784 52.5632 60.3784 53.7598 59.6632 54.8248C58.6016 56.4083 57.1071 57.6477 55.3607 58.3928C54.7692 58.6446 54.1544 58.8369 53.5253 58.9667C52.8766 59.0999 52.2163 59.1669 51.5544 59.1667ZM44.8438 59.1667H36.0053L36.0033 59.1663L36.0016 59.1652L36.0004 59.1636L36 59.1616V45.5142C35.9999 44.9044 36.0608 44.2961 36.1818 43.6986C36.4162 42.5462 36.8736 41.4516 37.528 40.4774C38.4991 39.0289 39.8662 37.8952 41.4638 37.2135C42.0048 36.9832 42.5672 36.8073 43.1426 36.6886C43.7361 36.5667 44.3403 36.5054 44.946 36.5056V36.5C45.966 36.5008 46.9645 36.796 47.8232 37.3509C48.6819 37.9057 49.3651 38.6967 49.7913 39.6305C48.117 39.9387 46.5515 40.6831 45.2511 41.7895C44.398 42.5142 43.6736 43.3801 43.1092 44.35C42.4034 45.5697 41.9659 46.9279 41.8263 48.3327C41.6867 49.7376 41.8483 51.1563 42.3001 52.4927C42.752 53.8292 43.4835 55.0522 44.4452 56.0791C45.4069 57.106 46.5766 57.913 47.8746 58.4449C46.9341 58.9203 45.896 59.1674 44.8438 59.1667Z",
    fill: "url(#paint1_linear_16282_90556)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_16282_90556",
    x: 0,
    y: 0.5,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_16282_90556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16282_90556",
    x1: 75.8615,
    y1: 7.70001,
    x2: 16.2413,
    y2: 97.3372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281884,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6123E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16282_90556",
    x1: 63.3713,
    y1: 28.5667,
    x2: 36.5396,
    y2: 73.6534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281884,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6123E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiNanaBo);
export default __webpack_public_path__ + "static/media/ai-nana-bo.e0286ae5337f5a57421c8df8c111e2c7.svg";
export { ForwardRef as ReactComponent };